<template>
  <div class="app-order-payment">
    <slot name="txtBefore"></slot>
    <PaymentWrapper :credit-card-redirect-url="creditCardRedirectUrl"
                    :credit-card-frame-address="creditCardFrameAddress"
                    :payment.sync="payment_"
                    :paymentInvalid.sync="paymentInvalid_"
                    :payment-context="paymentContext"
                    :process-name="'orderProduct'"
                    :has-top-up="hasTopUp"
                    :paypal-possible="true"
    >
      <template v-for="slot in possibleChildSlotsFor('Payment')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </PaymentWrapper>
    <div class="order-step">
      <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
        <b-button @click="next" class="btn-next" :disabled="loading || paymentInvalid_" type="button" variant="primary">
          <slot name="btnNext">weiter</slot>
        </b-button>
      </b-overlay>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import PaymentWrapper from '../../../generic/Order/PaymentWrapper.vue'
import slotProxy from '@/mixins/slotProxy'
import preFilledObjectInput from '@/mixins/preFilledObjectInput'
import gtmEvent from '@/mixins/gtmEvent'

export const stepName = 'payment'
export default {
  name: 'EnterPaymentData',
  data () {
    return {
      loading: false,
      paymentInvalid_: true
    }
  },
  mixins: [
    slotProxy(),
    preFilledObjectInput('payment', 'storedPayment'),
    gtmEvent
  ],
  validations () {
    return {
      paymentInvalid_: {
        validPaymentIfRequired: (value, vm) => {
          if (vm.paymentRequired === false) {
            return true
          }
          return value === false
        }
      }
    }
  },
  components: { PaymentWrapper },
  computed: {
    ...mapGetters('orderProduct', [
      'getStep'
    ]),
    ...mapGetters('orderProduct/payment', {
      paymentContext: 'paymentContext',
      storedPayment: 'payment'
    }),
    ...mapGetters('orderProduct/topUp', [
      'hasTopUp'
    ]),
    ...mapGetters('orderProduct/gtmEventData', [
      'getTariffName',
      'getTariffProductNumber',
      'getTariffPrice'
    ]),
    fullNameAccountOwner () {
      return this.paymentContext.firstName + ' ' + this.paymentContext.lastName
    }
  },
  methods: {
    ...mapActions('orderProduct', [
      'initiateOrder'
    ]),
    ...mapActions('orderProduct/payment', [
      'validateAndSavePayment'
    ]),
    async next () {
      this.loading = true
      this.payment.owner = this.fullNameAccountOwner
      const validate = await this.validateAndSavePayment({ paymentData: this.payment })
      if (validate) {
        await this.initiateOrder({ step: this.nextStep })
      }
      this.pushEventCheckout('eec.checkoutStep', this.getStep, this.getTariffName, this.getTariffProductNumber, this.getTariffPrice, 'fyve')
      this.loading = false
    }
  },
  props: {
    nextStep: {
      type: String,
      default: 'summary'
    },
    creditCardFrameAddress: {
      type: String
    },
    creditCardRedirectUrl: {
      type: String
    }
  }
}
</script>
